import { GRACE_PAWPPER } from './constants';

// RUM user pool for Product Analytics users
// prettier-ignore
export const RUM_USER_POOL = [
  'bella.barker', 'max.retriever', 'charlie.spaniel', 'lucy.beagle', 'cooper.terrier',
  'daisy.poodle', 'rocky.bulldog', 'sadie.collie', 'buddy.shepherd', 'molly.husky',
  'duke.boxer', 'bailey.lab', 'jack.schnauzer', 'sophie.dachshund', 'oliver.corgi',
  'chloe.pug', 'bear.rottweiler', 'lola.maltese', 'zeus.dane', 'penny.shiba',
  'winston.aussie', 'ruby.pointer', 'teddy.yorkie', 'maggie.setter', 'bentley.mastiff',
  'stella.bichon', 'tucker.weimaraner', 'nala.vizsla', 'leo.akita', 'willow.papillon',
  'finn.newfie', 'pepper.havanese', 'henry.chihuahua', 'rosie.whippet', 'jake.samoyed',
  'emma.keeshond', 'diesel.doberman', 'zoe.basenji', 'gus.borzoi', 'lily.saluki',
  'harley.malamute', 'mia.afghan', 'toby.elkhound', 'coco.komondor', 'scout.kuvasz',
  'luna.briard', 'murphy.leonberger', 'abby.lowchen', 'apollo.bloodhound', 'gracie.otterhound',
  'archie.airedale', 'pearl.pointer', 'buster.beagle', 'ivy.irishsetter', 'ranger.ridgeback',
  'nova.norfolk', 'bruno.brittany', 'willow.weimaraner', 'atlas.akita', 'penny.papillon',
  'rex.russell', 'hazel.harrier', 'duke.dachshund', 'ruby.rottweiler', 'maverick.mastiff',
  'stella.springer', 'thor.terrier', 'bella.border', 'zeus.zwergschnauzer', 'luna.labrador',
  'charlie.cattledog', 'max.malamute', 'cooper.cairn', 'daisy.dalmatian', 'rocky.retriever',
  'sadie.schnauzer', 'buddy.beagle', 'molly.maltese', 'bailey.basenji', 'jack.jackrussell',
  'oliver.otterhound', 'chloe.cocker', 'bear.belgian', 'lola.leonberger', 'penny.pinscher',
  'winston.whippet', 'ruby.retriever', 'teddy.terrier', 'maggie.malinois', 'bentley.bulldog',
  'stella.sheepdog', 'tucker.tibetan', 'nala.norwich', 'leo.lhasa', 'willow.welshcorgi',
  'finn.foxhound', 'pepper.poodle', 'henry.husky', 'rosie.rottweiler', 'jake.jindo',
  'emma.elkhound', 'diesel.doberman', 'zoe.zwergschnauzer', 'gus.germanshepherd', 'lily.lakeland',
  'harley.havanese', 'mia.manchester', 'toby.terrier', 'coco.corgi', 'scout.setter',
  'luna.labrador', 'murphy.mastiff', 'abby.aussie', 'apollo.anatolian', 'gracie.gordon',
  'archie.azawakh', 'pearl.pekingese', 'buster.boston', 'ivy.irishsetter', 'ranger.ridgeback',
  'nova.newfie', 'bruno.bullmastiff', 'willow.wolfhound', 'atlas.aussie', 'penny.pyrenees',
  'rex.redbone', 'hazel.harrier', 'duke.dalmatian', 'ruby.retriever', 'maverick.mastiff',
  'stella.saluki', 'thor.terrier', 'bella.bluetick', 'zeus.zwergschnauzer', 'luna.labrador',
  'charlie.clumber', 'max.mastiff', 'cooper.collie', 'daisy.dachshund', 'rocky.ridgeback',
  'sadie.staffordshire', 'buddy.barbet', 'molly.maltese', 'bailey.beauceron', 'jack.jindo',
  'oliver.otterhound', 'chloe.chinook', 'bear.briard', 'lola.leonberger', 'penny.pointer',
  'winston.whippet', 'ruby.retriever', 'teddy.terrier', 'maggie.malinois', 'bentley.boxer',
  'stella.saluki', 'tucker.tamaskan', 'nala.norfolk', 'leo.leonberger', 'willow.wirehaired',
  'finn.flatcoat', 'pepper.patterdale', 'henry.hovawart', 'rosie.ridgeback', 'jake.jindo',
  'emma.entlebucher', 'diesel.doberman', 'zoe.zwergschnauzer', 'gus.greyhound', 'lily.lowchen',
  'harley.husky', 'mia.malinois', 'toby.tervuren', 'coco.corgi', 'scout.schipperke',
  'luna.lapphund', 'murphy.mastiff', 'abby.affenpinscher', 'apollo.appenzeller', 'gracie.golden',
  'archie.aussie', 'pearl.poodle', 'buster.bernese', 'ivy.ibizan', 'ranger.retriever',
  'nova.newfoundland', 'bruno.bergamasco', 'willow.wirehaired', 'atlas.akita', 'penny.papillon',
  'rex.retriever', 'hazel.hokkaido', 'duke.dalmatian', 'ruby.ridgeback', 'maverick.mastiff',
  'stella.setter', 'thor.terrier', 'bella.beagle', 'zeus.zwergschnauzer', 'luna.labrador',
  'charlie.cairn', 'max.malamute', 'cooper.collie', 'daisy.doberman', 'rocky.rottweiler',
  'sadie.setter', 'buddy.boxer', 'molly.maltese', 'bailey.barbet', 'jack.jindo',
  'oliver.otterhound', 'chloe.chihuahua', 'bear.bernese', 'lola.labrador', 'penny.pomeranian',
  'winston.wolfhound', 'ruby.retriever', 'teddy.terrier', 'maggie.mastiff', 'bentley.beagle',
  'stella.shepherd', 'tucker.terrier', 'nala.newfoundland', 'leo.leonberger', 'willow.whippet',
  'finn.foxhound', 'pepper.pointer', 'henry.husky', 'rosie.ridgeback', 'jake.jackrussell',
  'emma.elkhound', 'diesel.doberman', 'zoe.zwergschnauzer', 'gus.greyhound', 'lily.labrador',
  'harley.hound', 'mia.malinois', 'toby.terrier', 'coco.corgi', 'scout.schnauzer',
  'luna.labradoodle', 'murphy.malamute', 'abby.akita', 'apollo.aussie', 'gracie.golden',
  'archie.airedale', 'pearl.pug', 'buster.bulldog', 'ivy.irishsetter', 'ranger.retriever',
  'nova.newfie', 'bruno.boxer', 'willow.weimaraner', 'atlas.aussie', 'penny.poodle',
  'rex.retriever', 'hazel.harrier', 'duke.dachshund', 'ruby.rottweiler', 'maverick.mastiff',
  'stella.setter', 'thor.terrier', 'bella.basenji', 'zeus.zwergschnauzer', 'luna.labrador',
  'charlie.canaan', 'max.mastiff', 'cooper.collie', 'daisy.dalmatian', 'rocky.ridgeback',
  'sadie.sloughi', 'buddy.basenji', 'molly.maltese', 'bailey.barbet', 'jack.jindo',
  'oliver.otterhound', 'chloe.chow', 'bear.bouvier', 'lola.lagotto', 'penny.papillon',
  'winston.whippet', 'ruby.retriever', 'teddy.terrier', 'maggie.malinois', 'bentley.bulldog',
  'stella.springer', 'tucker.terrier', 'nala.norfolk', 'leo.lhasa', 'willow.wirehaired',
  'finn.flatcoat', 'pepper.poodle', 'henry.hovawart', 'rosie.rottweiler', 'jake.jindo',
  'emma.entlebucher', 'diesel.doberman', 'zoe.zwergschnauzer', 'gus.greyhound', 'lily.lakeland',
  'harley.havanese', 'mia.maltese', 'toby.tervuren', 'coco.corgi', 'scout.schipperke',
  'luna.lapphund', 'murphy.mountain', 'abby.affenpinscher', 'apollo.appenzeller', 'gracie.germanshepherd',
  'archie.akita', 'pearl.pointer', 'buster.beagle', 'ivy.ibizan', 'ranger.ridgeback',
  'nova.norfolk', 'bruno.briard', 'willow.wolfhound', 'atlas.anatolian', 'penny.pekingese',
  'rex.redbone', 'hazel.hokkaido', 'duke.dalmatian', 'ruby.rat', 'maverick.maremma',
  'stella.saluki', 'thor.tosa', 'bella.brittany', 'zeus.zwergschnauzer', 'luna.leonberger',
  'charlie.chow', 'max.malamute', 'cooper.collie', 'daisy.dalmatian', 'rocky.ridgeback',
  'sadie.springer', 'buddy.bloodhound', 'molly.maltese', 'bailey.boxer', 'jack.jackrussell',
  'oliver.otterhound', 'chloe.chihuahua', 'bear.bernese', 'lola.labrador', 'penny.pomeranian',
  'winston.wolfhound', 'ruby.rottweiler', 'teddy.terrier', 'maggie.mastiff', 'bentley.beagle',
  'stella.shepherd', 'tucker.terrier', 'nala.newfoundland', 'leo.leonberger', 'willow.whippet',
  'finn.foxhound', 'pepper.pointer', 'henry.husky', 'rosie.retriever', 'jake.jackrussell',
  'emma.elkhound', 'diesel.doberman', 'zoe.zwergschnauzer', 'gus.greyhound', 'lily.labrador',
  'harley.hound', 'mia.malinois', 'toby.terrier', 'coco.corgi', 'scout.schnauzer',
  'luna.labradoodle', 'murphy.malamute', 'abby.akita', 'apollo.aussie', 'gracie.golden',
  'archie.airedale', 'pearl.pug', 'buster.bulldog', 'ivy.irishsetter', 'ranger.retriever',
  'nova.newfie', 'bruno.boxer', 'willow.weimaraner', 'atlas.aussie', 'penny.poodle',
  'rex.retriever', 'hazel.husky', 'duke.dalmatian', 'ruby.ridgeback', 'maverick.mastiff',
  'stella.setter', 'thor.terrier', 'bella.bulldog', 'zeus.zwergschnauzer', 'luna.labrador'
] as const;

export const getRumUser = (): string => {
  // Check if a user id is already set in this session
  let userId = sessionStorage.getItem('user_id');

  if (!userId) {
    // 5% chance of generating a "new user"
    if (Math.random() < 0.05) {
      userId = generateNewUserId();
    }
    // 1% chance of being Grace Pawpper ("power user")
    else if (Math.random() < 0.01) {
      userId = GRACE_PAWPPER.USERNAME;
    }
    // Otherwise select from the pool ("returning user")
    else {
      userId = RUM_USER_POOL[Math.floor(Math.random() * RUM_USER_POOL.length)];
    }

    sessionStorage.setItem('user_id', userId);
  }

  return userId;
};

// Generate a unique new user ID (for simulating "new users")
const generateNewUserId = (): string => {
  const poolSize = RUM_USER_POOL.length;

  // Pick two random users
  const firstIndex = Math.floor(Math.random() * poolSize);
  const secondIndex = Math.floor(Math.random() * poolSize);

  // Get first name from first user, last name from second user
  const firstName = RUM_USER_POOL[firstIndex].split('.')[0];
  const lastName = RUM_USER_POOL[secondIndex].split('.')[1];

  // Add random 2-digit number (00-99) to make it clear it isn't part of the pool
  const randomNum = Math.floor(Math.random() * 100)
    .toString()
    .padStart(2, '0');

  return `${firstName}.${lastName}${randomNum}`;
};
